// src/features/bookings/components/BookingForm/cards/BasicInfoCard.jsx
import React from 'react';
import styles from '../../../../../components/Form.module.css';
import ClientSelect from '../../../../clients/components/ClientSelect';

function BasicInfoCard({
  bookingData, handleBookingChange,
  clients, handleClientChange,
  openClientModal, loadingClients,
  allowedBookingTypes,
}) {
  return (
    <fieldset className={styles.fieldset}>
      <legend className={styles.legend}>المعلومات الأساسية</legend>
      <div className={styles.inputGrid}>

        <ClientSelect
          clients={clients}
          value={bookingData.client_id}
          onChange={handleClientChange}
          onAddNew={openClientModal}
          isLoading={loadingClients}
          placeholder="-- اختر أو ابحث عن العميل --"
        />

        <select
          name="booking_type"
          value={bookingData.booking_type}
          onChange={handleBookingChange}
          required
        >
          <option value="">
            {allowedBookingTypes.length > 0 ? '-- اختر نوع الحجز --' : 'لا توجد أقسام مصرح بها'}
          </option>
          {allowedBookingTypes.map(type => (
            <option key={type.value} value={type.value}>{type.label}</option>
          ))}
        </select>

        <input
          type="date"
          name="booking_date"
          value={bookingData.booking_date}
          onChange={handleBookingChange}
        />

        {bookingData.booking_type !== 'graduation' && (
          <input
            type="number"
            step="any"
            name="total_price"
            value={bookingData.total_price}
            onChange={handleBookingChange}
            placeholder="السعر الإجمالي (افتراضي: 0.00)"
          />
        )}

      </div>
    </fieldset>
  );
}

export default BasicInfoCard;